import { render, staticRenderFns } from "./CgaControlHeading.vue?vue&type=template&id=02a7082e&scoped=true&"
import script from "./CgaControlHeading.vue?vue&type=script&lang=js&"
export * from "./CgaControlHeading.vue?vue&type=script&lang=js&"
import style0 from "./CgaControlHeading.vue?vue&type=style&index=0&id=02a7082e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a7082e",
  null
  
)

export default component.exports